import React from 'react';

export default function DateTimeField({ value, onChange, mode, type = "datetime-local", config, ...props }) {
    if (mode === "view") return <span>{value}</span>;
    
    const getInputType = () => {
        switch (type) {
            case "DATE":
                return "date";
            case "TIME":
                return "time";
            case "DATETIME":
            default:
                return "datetime-local";
        }
    };

    // Format value for HTML input
    const formatValueForInput = (value) => {
        if (!value) return "";
        
        try {
            const date = new Date(value);
            if (isNaN(date.getTime())) return value; // Return original if invalid date
            
            switch (type) {
                case "DATE":
                    return date.toISOString().split('T')[0]; // YYYY-MM-DD
                case "TIME":
                    return date.toTimeString().split(' ')[0]; // HH:MM:SS
                case "DATETIME":
                default:
                    // Format for datetime-local input: YYYY-MM-DDTHH:MM
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    return `${year}-${month}-${day}T${hours}:${minutes}`;
            }
        } catch (error) {
            console.warn('Error formatting datetime value:', error);
            return value; // Return original value if formatting fails
        }
    };

    const formattedValue = formatValueForInput(value);

    return (
        <input 
            type={getInputType()} 
            value={formattedValue} 
            onChange={e => onChange(e.target.value)} 
            className="form-control"
            {...props}
        />
    );
} 